// Central notification helpers for frontend
export const USER_NOTIF_SUBCOLLECTION = 'notifications';
export const ADMIN_NOTIF_COLLECTION = 'admin_notifications';

export const buildUserNotificationsPath = (userId) => `users/${userId}/${USER_NOTIF_SUBCOLLECTION}`;

export const normalizeNotification = (raw = {}) => {
  const n = Object.assign({}, raw);
  // Ensure boolean read
  if (typeof n.read !== 'boolean') n.read = Boolean(n.read);
  // Ensure createdAt exists (could be Timestamp or Date)
  if (!n.createdAt) n.createdAt = null;
  // Ensure strings
  if (!n.message) n.message = n.body || '';
  if (!n.title) n.title = '';
  if (!n.type) n.type = '';
  if (!n.link) n.link = null;
  if (!n.metadata) n.metadata = null;
  return n;
};
